import { toValue } from 'vue'
import DefaultLayout from './DefaultLayout.vue'
import EmptyLayout from './EmptyLayout.vue'

export const LAYOUTS = {
  default: DefaultLayout,
  empty: EmptyLayout,
}

export function useLayout (layout) {
  return LAYOUTS[toValue(layout)]
}
